<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Create Your Parish Online Password</span>
    </v-row>
    <v-row no-gutters>
      <span class="body-2">
        Please set a secure password for your Parish Online account.
      </span>
    </v-row>
    <v-row no-gutters>
      <span class="body-2">
        It must contain: upper case, lower case, number, special character, and be a minimum of 10 characters.
      </span>
    </v-row>

    <v-row no-gutters class="mt-4">
      <v-col>
        <span class="body-2">Create a password for your Parish Online account:</span>
        <v-text-field outlined dense counter filled
                      v-model="passwordInput"
                      class="mt-1"
                      :error-messages="checkPassword"
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                      @click:append="showPassword = !showPassword"

        ></v-text-field>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Password Strength</span>
    </v-row>
    <v-list dense>
      <v-list-item v-for="item in passwordCheck">
        <v-list-item-icon>
          <v-icon v-if="item.value" color="success">check_circle</v-icon>
          <v-icon v-else color="error">error</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
  export default {
    name: "StepNine",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        passwordInput: '',
        showPassword: false,
        passwordCheck: {
          length: {
            text: 'Minimum length of 10',
            value: false,
          },
          uppercase: {
            text: 'Contains an uppercase character',
            value: false
          },
          lowercase: {
            text: 'Contains a lowercase character',
            value: false
          },
          number: {
            text: 'Contains a number',
            value: false
          },
          special: {
            text: 'Contains a special character',
            value: false
          },
        }
      }
    },
    computed: {
      checkPassword() {
        let messages = [];
        let uppercase = this.hasUpperCase;
        let lowercase = this.hasLowerCase;
        let length = this.hasLength;
        let number = this.hasNumber;
        let special = this.hasSpecial;

        if (this.passwordInput !== '') {
          length.forEach((message) => {
            messages.push(message);
          });

          uppercase.forEach((message) => {
            messages.push(message);
          });

          lowercase.forEach((message) => {
            messages.push(message);
          });

          number.forEach((message) => {
            messages.push(message);
          });

          special.forEach((message) => {
            messages.push(message);
          });
        }

        this.$emit('update:valid', (messages.length === 0 && this.passwordInput.length !== 0));
        if (this.valid) {
          this.$store.commit('SET_PASSWORD', this.passwordInput);
        }

        return messages;
      },
      hasUpperCase() {
        let string = this.passwordInput;
        let regex = /[A-Z]/;
        let messages = [];

        if (!string.match(regex)) {
          messages.push('Does not contain an uppercase character');
          this.passwordCheck.uppercase.value = false;
        } else {
          messages = [];
          this.passwordCheck.uppercase.value = true;
        }
        return messages;
      },
      hasLowerCase() {
        let string = this.passwordInput;
        let regex = /[a-z]/;
        let messages = [];

        if (!string.match(regex)) {
          messages.push('Does not contain an lowercase character');
          this.passwordCheck.lowercase.value = false;
        } else {
          messages = [];
          this.passwordCheck.lowercase.value = true;
        }
        return messages;
      },
      hasLength() {
        let string = this.passwordInput;
        let messages = [];

        if (string.length < 10) {
          messages.push('Does not meet length requirements');
          this.passwordCheck.length.value = false;
        } else {
          messages = [];
          this.passwordCheck.length.value = true;
        }
        return messages;
      },
      hasNumber() {
        let string = this.passwordInput;
        let regex = /[0-9]/;
        let messages = [];

        if (!string.match(regex)) {
          messages.push('Does not contain an number');
          this.passwordCheck.number.value = false;
        } else {
          messages = [];
          this.passwordCheck.number.value = true;
        }
        return messages;
      },
      hasSpecial() {
        let string = this.passwordInput;
        let regex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        let messages = [];

        if (!string.match(regex)) {
          messages.push('Does not contain a special character');
          this.passwordCheck.special.value = false;
        } else {
          messages = [];
          this.passwordCheck.special.value = true;
        }
        return messages;
      },
    },
    methods: {}
  }
</script>
